import { render, staticRenderFns } from "./DocumentSendReview.vue?vue&type=template&id=e1f14f3e&scoped=true"
import script from "./DocumentSendReview.vue?vue&type=script&lang=js"
export * from "./DocumentSendReview.vue?vue&type=script&lang=js"
import style0 from "./DocumentSendReview.vue?vue&type=style&index=0&id=e1f14f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f14f3e",
  null
  
)

export default component.exports